// A/B testing
// There are the AB Test 1 and AB Test 2 etc. slots to run Control or Test variants randomly. Test variant controls what is rendered, see pages/Booking.
export enum AbTestVariants {
  Control,
  Test1
}

export interface UiState {
  isCtmNumberReady: boolean

  // A/B testing
  // There are the AB Test 1 and AB Test 2 etc. slots to run Control or Test variants randomly. Test variant controls what is rendered, see pages/Booking.
  abTestVariant: AbTestVariants
}
